import { Box, Fade, Grid } from '@mui/material';
import { forwardRef } from 'react';
import AccessModeRadioGroup from './AccessModeRadioGroup';
import CreateAccount from './CreateAccount';
import CreateContextLogin from './CreateContextLogin';
import { useSignUpContext } from './SignUp.context';

const UserStep = forwardRef((_, ref) => {
  const { state, handleSetUserMode } = useSignUpContext();
  const { store } = state;

  return (
    <Box ref={ref}>
      <Grid
        container
        spacing={3}
        sx={{
          justifyContent: 'center',
        }}
      >
        <Grid size={12}>
          <AccessModeRadioGroup value={state.userMode} onChange={handleSetUserMode} />
        </Grid>
        <Grid size={12}>
          <Fade
            in={state.userMode === 'NEW'}
            appear={false}
            unmountOnExit
            timeout={200}
            exit={false}
          >
            <div>
              <CreateAccount store={store} isActive={state.userMode === 'NEW'} />
            </div>
          </Fade>
          <Fade
            in={state.userMode === 'EXISTENT'}
            appear={false}
            unmountOnExit
            timeout={200}
            exit={false}
          >
            <div>
              <CreateContextLogin store={store} isActive={state.userMode === 'EXISTENT'} />
            </div>
          </Fade>
        </Grid>
      </Grid>
    </Box>
  );
});

export default UserStep;
